import { SelectItem } from 'primeng/components/common/selectitem';

import { IExternalOutputUriList, ILocation, IExternalOutputUriListMap } from '.';
import { VidNexVideoSource } from './vid-nex-video-source';
import { ISelectItemWithChildren } from './select-item';

export interface ICamera {
    id?: number;
    userId?: number;
    name?: string;
    description?: string;
    centerId?: number;
    centerName?: string;
    locationId?: number;
    locationName?: string;
    location?: ILocation;
    snapshotAddress?: string;
    sourceSystemId?: string;
    wowzaAppTemplateId?: number;
    wowzaServerId?: number;
    wowzaChannelId?: number;
    wowzaChannelName?: string;
    createdDateTime?: Date;
    createdBy?: string;
    modifiedDateTime?: Date;
    modifiedBy?: string;
    blockages?: any[];
    blockAllCameraDistribution?: boolean;
    isExternalSnapShot?: boolean;
    incomingStreamList?: any[];
    isBlockedExternally?: boolean;
    workFlowTypeId?: number;
    workFlowType?: string;    
    mobileCameraType?: string;
    wowzaExternalUrls?: IExternalOutputUriList;
    vncVideoSource?: VidNexVideoSource;
    snapshotStatus?: string;
    
    isSecureTokenEnabled?: boolean;

    // videoSource?: VidNexVideoSource;
    status?: string;
    agencyId?: number;
    countyId?: number;
    highwayId?: number;
    latitude?: number;
    longitude?: number;
    mileMarker?: string;
    direction?: string;
    blockedByUserGroup?: boolean;
    mobileCameraTypeId?: number;
}

export interface ICameraLite {
    id?: number;
    name?: string;
    status?: any;
    agency?: string;
    center?: string;
    county?: string;
    highway?: string;
    sourceSystemId?: string;
    channel?: string;
    isExternalSnapShot?: boolean;
    blockageCount?: number;
    isBlockedExternally?: boolean;
    workFlowTypeId?: number;    
    blockAllCameraDistribution?: boolean;
    videoAvailable?: boolean;
    blockedByUserGroup?: boolean;
    mobileCameraTypeId?: number;
}

export interface ICameraMap {
    id?: number;
    name?: string;
    description?: string;
    center?: string;
    channelId?: number;
    channel?: string;
    location?: ILocation;
    snapshotAddress?: string;
    videoUrl?: string;
    wowzaExternalUrls?: IExternalOutputUriList;
    blockages?: any[];
    blockAllCameraDistribution?: boolean;
    isBlockedExternal?: boolean;
    disabled?: boolean;
    isBlockedExternally?: boolean;
    workFlowTypeId?: number;    
    cameraStatus?: string;
    cameraStatusId?: number;
    hasError?: boolean;
    isSelected?: boolean;
    snapshotStatus?: string;
    status?: any;
    isSecureTokenEnabled?: boolean;
    blockedByUserGroup?: boolean;
    mobileCameraTypeId?: number;
}

export interface ICameraTour {
    id?: number,
    name?: string,
    channel?: string,
    channelId?: number,
    camerasNumber?: number,
    dwellTime?: number,
    userId?: number,
    wowzaChannelId?: number,
    wowzaChannelURL?: string,
    cameras?: ICameraDetail[],
    userGroupName?: string,
    sequence?: string,
    cameraTourNames?: string[]
}

export interface ICameraList {
    id?: number;
    name?: string;
    description?: string;
    center?: string;
    channel?: string;
    snapshotAddress?: string;
    snapshotThumbAddress?: string;
    sourceSystemId?: string;
    isExternalSnapShot?: boolean;
    wowzaExternalUrls?: IExternalOutputUriList;
    videoUrl?: string;
    blockAllCameraDistribution?: boolean;
    cameraStatus?: string;
    cameraType?: string;
    cameraStatusId?: number;
    agency?: string;
    county?: string;
    highway?: string;
    workFlowTypeId?: number;    
    blockage?: string;
    hasError?: boolean;
    isBlockedExternally?: boolean;
    agencyId?: number;
    countyId?: number;
    highwayId?: number;
    centerId?: number;
    isSelected?: boolean;
    videoNotAvailable?: boolean;
    snapshotStatus?: string;
    snapshotStatusId?: number;
    canBlockOrUnblock?: boolean;
    blockedByUserGroup?: boolean;
    wowzaServer?: string;
    mobileCameraTypeId?: number;
}

export interface ICameraForList {
    a: number; // id
    b: string; // name
    c?: string; // description
    d?: number; // center
    e?: string; // channel
    f?: string; // snapshot
    g?: IExternalOutputUriListMap;
    h?: number; // agency
    i?: number; // county
    j?: number; // highway
    k?: boolean; // block all cameras
    l?: number; // status
    m?: number; // workflow type
    n?: boolean; // has error
    o?: boolean; // external block
    //   t?: string; // direction
    p?: number; // snapshot status
    r?: boolean; // if wowza secure token enabled
    s?: boolean; // blocked by user group
    t?: number; // mobileCameraType
}

export interface ICamerasForList {
    cameras: ICameraForList[];
    centers: SelectItem[];
    counties: SelectItem[];
    highways: SelectItem[];
    agencies: IAgencySelectItem[];
    statuses: SelectItem[];
    snapshotStatuses: SelectItem[];
    blockageStatuses: SelectItem[];
    externallyBlocked: SelectItem[];
}

export interface IAgencySelectItem extends SelectItem {
    canBlock?: boolean;
}
export interface ICameraForMap {
    a: number; // id
    b: string; // name
    c?: string; // description
    d?: string; // agency
    e?: string; // county
    f?: string; // center
    g?: string; // highway
    h?: string; // snapshot
    i?: boolean; // block all camera distribution
    j?: number; // workFlowType
    k?: number; // channelId
    l?: boolean; // is blocked externally
    m?: number; // latitude
    n?: number; // longitude
    o?: IExternalOutputUriListMap;
    p?: boolean;
    r?: number; // MileMarker
    t?: string; // direction
    v?: string; // snapshot status
    w?: string; // status,
    x?: boolean; // if wowza secure token enabled
    y?: boolean; // blocked by user group
    z?: number; // mobileCameraType
}

export interface ICameraFiltersForConfig {
    centers: ISelectItemWithChildren[];
    counties: ISelectItemWithChildren[];
    highways: ISelectItemWithChildren[];
    agencies: ISelectItemWithChildren[];
    statuses: ISelectItemWithChildren[];
    blockageStatuses: ISelectItemWithChildren[];
    snapshotStatuses?: ISelectItemWithChildren[];
    externallyBlocked?: ISelectItemWithChildren[];
    wowzaTemplates: SelectItem[];
    wowzaServers: SelectItem[];
}

export interface ICamerasForConfig extends ICameraFiltersForConfig {
    cameras: ICameraList[];
}

export interface ICameraFilter {
    id?: string;
    name?: string;
    description?: string;
    wowzaServers: string[];
    agencies: number[];
    centers: number[];
    counties: number[];
    highways: number[];
    statuses: number[];
    blockageStatus: string[];
    externalBlockageStatus: string[];
    snapshotStatus?: number[];
    snapshotStatusAsString?: string;
    all?: string;
    sourceSystemId?: string;
    channel?: string;
    cameraType?: string;
    wowzaServer?: string;
}

export enum SnapshotStatusEnum {
    Unknown = 'Unknown',
    Recent = 'Recent',
    Stale = 'Stale',
    Unavailable = 'Unavailable',
    InvalidConfig = 'InvalidConfig'
}

export interface ICameraTourForList {
    id?: number,
    name?: string,
    channelName?: string,
    channelId?: number,
    camerasNumber?: number,
    wowzaChannelURL?: string,
    dwellTime?: string,
    userId?: number,
    canEdit?: boolean
}

export interface ICameraDetail {
    id?: number,
    name?: string,
    sequence?: number,
    cameraId?: number,
    highway?: string,
    agency?: string,
    order?: number,
    isBlocked: boolean
}